export const GET_WOOKAI_VENDORS = 'GET_WOOKAI_VENDORS';
export const SET_WOOKAI_VENDORS = 'SET_WOOKAI_VENDORS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_WOOKAI_VENDOR = 'SET_WOOKAI_VENDOR';
export const ADD_WOOKAI_VENDOR = 'ADD_WOOKAI_VENDOR';
export const EMPTY_WOOKAI_VENDOR = 'EMPTY_WOOKAI_VENDOR';
export const DELETE_WOOKAI_VENDOR = 'DELETE_WOOKAI_VENDOR';
export const EDIT_WOOKAI_VENDOR = 'EDIT_WOOKAI_VENDOR';
export const UPDATE_WOOKAI_VENDOR = 'UPDATE_WOOKAI_VENDOR';
export const SET_WOOKAI_VENDOR_FILTER = 'SET_WOOKAI_VENDOR_FILTER';